import * as React from 'react'
import { useMemo } from 'react'

import Stack from '@mui/material/Stack'

import { useSelectCustomFieldData } from '@user/store/customFields'
import { FormSectionTitle } from '../../FormComponents/FormSectionTitle'
import { CustomFieldListItem } from '../../FormComponents/CustomFields/CustomFieldListItem'
type Props = {
  hideOptional: boolean
}

export function OpportunityCustomFields(props: Props) {
  const { hideOptional } = props
  const data = useSelectCustomFieldData()

  const showCustomFields = useMemo(
    () =>
      !!data.orderedCustomFields.length &&
      !!data.customSettings.find((setting) => setting.enabled) &&
      (!hideOptional ||
        !!data.customSettings.find((setting) => setting.required)),
    [data.customSettings, data.orderedCustomFields.length, hideOptional],
  )

  return showCustomFields ? (
    <Stack gap={2} pb={2}>
      <FormSectionTitle>Custom Fields</FormSectionTitle>
      {data.orderedCustomFields?.map((field) => {
        return (
          <CustomFieldListItem
            key={field.id}
            field={field}
            hideOptional={hideOptional}
            customSettings={data.customSettings}
          />
        )
      })}
    </Stack>
  ) : null
}
